"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var utils_1 = require("../../core/utils");

var Snapshot_1 = require("../model/Snapshot");

var SnapshotType_1 = require("../model/SnapshotType");

var SnapshotConverter_1 = require("./SnapshotConverter");
/**
 * @author Adam Drda
 */


var SnapshotConverterImpl =
/*#__PURE__*/
function (_SnapshotConverter_1$) {
  _inherits(SnapshotConverterImpl, _SnapshotConverter_1$);

  function SnapshotConverterImpl() {
    _classCallCheck(this, SnapshotConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SnapshotConverterImpl).call(this));
  }

  _createClass(SnapshotConverterImpl, [{
    key: "getConverter",
    value: function getConverter(entityClass) {
      var entityConverter = typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        className: entityClass
      });

      if (!entityConverter) {
        throw new Error('Missing converter for ' + entityClass);
      }

      return entityConverter;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var entityConverter = this.getConverter(source.entityClass);
      var kpis = immutable_1.Map();

      if (source.entityKpiValues) {
        Object.keys(source.entityKpiValues).forEach(function (key) {
          var arr = source.entityKpiValues[key];

          if (!utils_1.Utils.isArray(arr)) {
            throw new Error('Expecting array');
          }

          var nom = conversions.toBigNumber(arr[0]);
          var denom = conversions.toBigNumber(arr[1]);
          kpis = kpis.set(key, [nom, denom]);
        });
      }

      var weights = null;

      if (source.splitWeights) {
        if (!utils_1.Utils.isArray(source.splitWeights)) {
          throw new DataDictionaryError_1.DataDictionaryError('SplitWeights array expected, but found: ' + JSON.stringify(source.splitWeights));
        }

        var sw = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = source.splitWeights[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var it = _step.value;

            if (!utils_1.Utils.isArray(it) || it.length !== 4) {
              throw new DataDictionaryError_1.DataDictionaryError('SplitWeights array item expected, but found: ' + JSON.stringify(source.splitWeights));
            }

            sw.push({
              date: conversions.toDate(it[0]),
              promoWeek: utils_1.Utils.asString(it[1]),
              calendarWeek: utils_1.Utils.asString(it[2]),
              amount: conversions.toBigNumber(it[4])
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        weights = immutable_1.List(sw);
      }

      return new Snapshot_1.Snapshot(conversions.documentToClassId(source), conversions.toDate(source.date), conversions.asEnum(source.type, SnapshotType_1.SnapshotType), source.entityClass, entityConverter.toObject(source.entity, conversions), source.entityKpiValues ? kpis : null, weights);
    }
  }, {
    key: "convertKpiValues",
    value: function convertKpiValues(kpiValues, conversions) {
      if (!kpiValues) {
        return null;
      }

      var ret = {};
      kpiValues.forEach(function (v, key) {
        ret[key] = [];
        ret[key][0] = conversions.fromBigNumber(v[0]);
        ret[key][1] = conversions.fromBigNumber(v[1]);
      });
      return ret;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var entityConverter = this.getConverter(source.entityClass);

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var kpiValues = this.convertKpiValues(source.entityKpiValues, conversions);
      var splitWeights = null;

      if (source.entitySplitWeights) {
        splitWeights = [];
        source.entitySplitWeights.forEach(function (sw) {
          return splitWeights.push([conversions.fromDate(sw.date), sw.promoWeek, sw.calendarWeek, conversions.fromBigNumber(sw.amount)]);
        });
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        date: conversions.fromDate(source.date),
        type: source.type,
        entityClass: source.entityClass,
        entity: entityConverter.toDocument(source.entity, conversions),
        entityKpiValues: kpiValues,
        entitySplitWeights: splitWeights
      });
      return result;
    }
  }]);

  return SnapshotConverterImpl;
}(SnapshotConverter_1.SnapshotConverter);

exports.SnapshotConverterImpl = SnapshotConverterImpl;